(function(module) {
    'use strict';

    function AdminAccountsCtrl($state, Includes, Account, Store) {
        this.$onInit = () => {

            // RESOLVE
            this.loading = true;
            this.orderBy = 'createdAt';

            Account.find({ filter: Includes.accounts })
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.accounts = Store.setMultiModelData('accounts', response);
                });

            this.currentAccount = Store.getCurrentAccount();
        };

        this.trialEndsIn = ({ type, agreementSignedDate, trialPeriod }) => {
            if (type !== 'free') return 'n/a';

            const agreementEndDate = moment(agreementSignedDate).clone().add(trialPeriod, 'days').endOf('day');
            return moment(agreementEndDate).diff(moment(), 'days');
        };
    }

    module
        .component('adminAccountsListComponent', {
            templateUrl: '/js/admin/accounts/accounts.html',
            controller: AdminAccountsCtrl,
        })
        .config(function($stateProvider) {
            $stateProvider
                .state('root.admin.accounts', {
                    url: '/accounts',
                    data: {
                        pageTitle: 'ADMIN_ACCOUNTS_LIST.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<admin-accounts-list-component/>',
                        },
                    },
                    bodyClass: 'page--admin-accounts',
                });

        });

})(angular.module('rocket.components'));
